import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {Analytics} from "@vercel/analytics/react";
import * as Sentry from "@sentry/react";
import { AuthProvider } from '@/contexts/AuthContext'

Sentry.init({
  dsn: "https://2hxnuZSBr1NqLAWQyVVA8pq9@s1682632.eu-nbg-2.betterstackdata.com/1682632",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Analytics />
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
